import React, { useState } from "react";
import * as S from "./WithdrawModalStyle";
import { FaTimes, FaSpinner } from "react-icons/fa";
import { formatNumber } from "../../../assets/utils";
import { goldenBoxService } from "../../../Services/goldenBoxService";

// Adicionei a prop 'onSuccess' para atualizar a tabela após cancelar
export default function WithdrawModal({ isOpen, onClose, data, onSuccess }) {
  const [canceling, setCanceling] = useState(false);

  if (!isOpen || !data) return null;

  const isPending = data.status === "PENDING";

  const handleCancelClick = async () => {
    const confirm = window.confirm(
      "Tem certeza que deseja cancelar esta solicitação de saque? O valor será estornado imediatamente para sua Caixinha."
    );

    if (!confirm) return;

    try {
      setCanceling(true);
      await goldenBoxService.cancelWithdraw(data.id);

      alert("Saque cancelado com sucesso! O valor foi estornado.");

      if (onSuccess) {
        onSuccess(); // Recarrega a tabela pai
      }
      onClose(); // Fecha o modal
    } catch (error) {
      console.error(error);
      const msg = error.response?.data?.message || "Erro ao cancelar saque.";
      alert(msg);
    } finally {
      setCanceling(false);
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "PENDING":
        return "Pendente";
      case "PAID":
        return "Pago";
      case "CANCELED":
        return "Cancelado";
      case "REJECTED":
        return "Rejeitado";
      default:
        return status;
    }
  };

  return (
    <S.Overlay onClick={onClose}>
      <S.Container onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <h2>Detalhes do Saque #{data.id}</h2>
          <button onClick={onClose} disabled={canceling}>
            <FaTimes />
          </button>
        </S.Header>

        <S.Body>
          <S.InfoRow>
            <span className="label">Data da Solicitação</span>
            <span className="value">
              {data.dateCreated
                ? new Date(data.dateCreated).toLocaleString("pt-BR")
                : "-"}
            </span>
          </S.InfoRow>

          <S.InfoRow>
            <span className="label">Caixinha de Origem</span>
            <span className="value">
              {data.goldenBoxId ? `#${data.goldenBoxId}` : "N/A"}
            </span>
          </S.InfoRow>

          <S.InfoRow>
            <span className="label">Status Atual</span>
            <S.StatusBadge status={data.status}>
              {getStatusLabel(data.status)}
            </S.StatusBadge>
          </S.InfoRow>

          <S.InfoRow>
            <span className="label">Valor Solicitado</span>
            <span className="value">
              R$ {formatNumber(data.amountWithdrawn)}
            </span>
          </S.InfoRow>

          <S.InfoRow>
            <span className="label">Valor Líquido a Receber</span>
            <span className="value highlight">
              R${" "}
              {formatNumber(
                data.amountWithdrawnReceivable ?? data.amountWithdrawn
              )}
            </span>
          </S.InfoRow>

          {data.approvalDate && (
            <S.InfoRow>
              <span className="label">Data de Aprovação</span>
              <span className="value">
                {new Date(data.approvalDate).toLocaleString("pt-BR")}
              </span>
            </S.InfoRow>
          )}
        </S.Body>

        <S.Footer>
          <S.Button onClick={onClose} disabled={canceling}>
            Fechar
          </S.Button>

          {isPending && (
            <S.Button
              cancel
              onClick={handleCancelClick}
              disabled={canceling}
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              {canceling ? (
                <>
                  <FaSpinner
                    className="spinner"
                    style={{ animation: "spin 1s linear infinite" }}
                  />
                  Cancelando...
                  <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                </>
              ) : (
                "Cancelar Solicitação"
              )}
            </S.Button>
          )}
        </S.Footer>
      </S.Container>
    </S.Overlay>
  );
}
